import { cn } from '@eliadmin/core/src/utils/style-utils';
import { HtmlRendererRaw } from '@eliadmin/core/src/components/ui/html-renderer-raw';

export const HtmlDescription = ({
  content,
  size,
  className,
  color,
}: {
  content: string;
  className?: string;
  size: 'sm' | 'md' | 'lg';
  color: 'white' | 'foreground' | 'muted-foreground';
}) => {
  return (
    <HtmlRendererRaw
      className={cn(
        'ea-html-description',
        className,
        size === 'sm' && 'ea-html-description--sm',
        size === 'md' && 'ea-html-description--base',
        size === 'lg' && 'ea-html-description--lg',
        color === 'white' && 'text-white',
        color === 'foreground' && 'text-foreground',
        color === 'muted-foreground' && 'text-muted-foreground',
      )}
      html={content}
    />
  );
};
